import {
    Box,
    IconButton,
    useTheme,
    Stack, InputBase
} from "@mui/material";
import {observer} from "mobx-react-lite";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { tokens } from "../../theme";
import { useState, useEffect } from "react";
import useResponsive from "../../hooks/useResponsive";
import AppealListElement from "./AppealListElement";
import Header from "./Header";
import SearchIcon from "@mui/icons-material/Search";
import appealsStore from '../../store/appealsStore';
import AppealService from "../../services/AppealService";
import ProviderService from "../../services/ProviderService";

const Appeals = ({handleOpenSearch=null, handleOpenQueue}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const isDesktop = useResponsive("up", "md");

    const searchButton = handleOpenSearch ? true : false

    const [search, setSearch] = useState('')
    const providers = appealsStore.getProviders();
    const appealGroups = appealsStore.getAppealGroup();
    // const [scrollPosition, setScrollPosition] = useState(0);
    // const [appealsCount, setAppealsCount] = useState(0)
    const [status, setStatus] = useState(1);

    // useEffect(() => {
    //     const subscribe = async () => {
    //         const providers = await ProviderService.getProviders();
    //         setProviders(providers.data.providers)
    //         const appealGroups = await AppealService.getAppealGroup();
    //         setAppealGroups(appealGroups.data.appeal_groups)
    //     }
    //     subscribe()
    // }, [  ])

    useEffect(() => {
        appealsStore.setFilterModel({
            provider: appealsStore.filterModel.provider,
            group: appealsStore.filterModel.group,
            open: appealsStore.filterModel.open,
            close: appealsStore.filterModel.close,
            filter: search,
        })
    }, [search])

    const handleAppealClick = (appeal) => {
        appealsStore.fetchAppeal(appeal)
    };

    const handleChangeProvider = (event, newValue) => {

        appealsStore.setFilterModel({
            provider: newValue,
            group: 0,
            open: 1,
            close: 0,
            filter: appealsStore.filterModel.filter,
        })
    };

    // const getProvider = (provider_id) => providers.find(provider => provider.id === provider_id)

    const handleChangeGroup = (event, newValue) => {

        appealsStore.setFilterModel({
            provider: appealsStore.filterModel.provider,
            group: newValue,
            open: appealsStore.filterModel.open,
            close: appealsStore.filterModel.close,
            filter: appealsStore.filterModel.filter,
        })
    };

    const handleChangeStatus = (event, newValue) => {
        setStatus(newValue)
        switch(newValue) {
            case 0:
                appealsStore.setFilterModel({
                    provider: appealsStore.filterModel.provider,
                    group: appealsStore.filterModel.group,
                    open: 1,
                    close: 1,
                    filter: appealsStore.filterModel.filter,})
                break
            case 1:
                appealsStore.setFilterModel({
                    provider: appealsStore.filterModel.provider,
                    group: appealsStore.filterModel.group,
                    open: 1,
                    close: 0,
                    filter: appealsStore.filterModel.filter,
                })
                break
            case 2:
                appealsStore.setFilterModel({
                    provider: appealsStore.filterModel.provider,
                    group: appealsStore.filterModel.group,
                    open: 0,
                    close: 1,
                    filter: appealsStore.filterModel.filter,
                })
                break
            default:
                break
        }
    };

    const handleScroll = (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.target;
        const scrollEnd = scrollTop + clientHeight + 1
        if (scrollEnd >= scrollHeight ) {
            appealsStore.fetchNextAppeals()
        }
    };

    return (
        <Box
            sx={{
                position: "relative",
                // height: "100%",
                minWidth: "320px",
                width: isDesktop ? 320 : "100%",
                backgroundColor:
                    theme.palette.mode === "light"
                        ? "#F8FAFF"
                        : theme.palette.background,
                boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25)",
            }}
        >

            <Stack spacing={2} sx={{ maxHeight: "100%"}}>
                {searchButton && <Header  handleOpenSearch={handleOpenSearch} handleOpenQueue={handleOpenQueue}/>}
                <Stack sx={{ width: "100%" }}>
                    <Box
                        display="flex"
                        backgroundColor={colors.primary[400]}
                        borderRadius="3px"
                        m={1}
                    >
                        <InputBase
                            sx={{ ml: 2, flex: 1 }}
                            placeholder="Search"
                            onChange={e => setSearch(e.target.value)}
                            value={search}
                        />
                        <IconButton type="button" sx={{ p: 1 }}>
                            <SearchIcon />
                        </IconButton>
                    </Box>
                    {providers.length > 1
                        ? <Box>
                            <Tabs
                                value={appealsStore.filterModel.provider}
                                onChange={handleChangeProvider}
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="disabled tabs example"
                            >
                                <Tab value={0} label="All" wrapped/>
                                {providers.map((el) => {
                                    return <Tab value={ el.id } label={ el.name } wrapped/>;
                                })}
                            </Tabs>
                        </Box>
                        : <></>
                    }
                    {appealGroups.length > 1
                        ? <Box>
                            <Tabs
                                value={appealsStore.filterModel.group}
                                onChange={handleChangeGroup}
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="disabled tabs example"
                            >
                                <Tab value={0} label="All" wrapped/>
                                {appealGroups.map((el) => {
                                    if (el.provider_id !== appealsStore.filterModel.provider && appealsStore.filterModel.provider !== 0) {
                                        return
                                    }
                                    return <Tab value={ el.id } label={ el.name } wrapped/>;
                                })}
                            </Tabs>
                        </Box>            
                        : <></>
                    }       
                    <Box>
                        <Tabs
                            value={status}
                            onChange={handleChangeStatus}
                            // variant="scrollable"
                            // scrollButtons="auto"
                            aria-label="disabled tabs example"
                        >
                            <Tab label="All" />
                            <Tab label="Open" />
                            <Tab label="Close" />
                        </Tabs>
                    </Box>
                </Stack>
                <Stack 
                    onScroll={handleScroll}
                    sx={{ 
                        // height: "100vw",
                        flexGrow: 1,
                        overflowY: "scroll"
                    }}
                >
                    <Stack spacing={1}>
                        {appealsStore.appeals.map((appeal) => {
                            return <AppealListElement
                                        appeal={appeal} 
                                        provider={providers.find(provider => provider.id === appeal.provider_id)}
                                        group={appealGroups.find(group => group.id === appeal.group_id)}
                                        handleAppealClick={handleAppealClick} 
                                        isSelected={appealsStore.appeal.id === appeal.id} 
                                    />;
                        })}
                        </Stack>
                </Stack>
            </Stack>
        </Box>
    )
};

export default observer(Appeals);